import { grey, blueGrey, orange, green, red } from "@mui/material/colors";

export function createEventTicketConstants() {
  const constants = {};

  constants.maxOffers = 10;

  constants.minGroupSize = 1;
  constants.midGroupSize = 15;
  constants.maxGroupSize = 30;

  constants.minCapacity = 2;
  constants.midCapacity = 100;
  constants.maxCapacity = 1000;

  constants.activeStates = [
    {
      value: "active",
      display: "active",
      color: green[200],
      textColor: "black",
      active: true,
    },
    {
      value: "inactive",
      display: "inactive",
      color: grey[600],
      textColor: "white",
      active: false,
    },
  ];

  constants.states = [
    {
      value: "initiated",
      display: "ticking",
      color: blueGrey[200],
      textColor: "black",
      offer: true,
      launch: false,
    },
    {
      value: "ticking",
      display: "ticking",
      color: orange[200],
      textColor: "black",
      offer: true,
      launch: false,
    },
    {
      value: "triggered",
      display: "launched",
      color: orange[500],
      textColor: "black",
      offer: false,
      launch: true,
      entry: true,
      ticketReady: true,
    },
    {
      value: "checked",
      display: "entered",
      color: green[500],
      textColor: "black",
      offer: false,
      launch: true,
      entry: true,
      entered: true,
    },
    {
      value: "checked:part",
      display: "part entered",
      color: green[500],
      textColor: "black",
      offer: false,
      launch: true,
      entry: true,
      entered: true,
    },
    {
      value: "incomplete",
      display: "payment issue",
      color: red[200],
      textColor: "black",
      offer: false,
      launch: true,
      entry: false,
      paymentRetry: true,
    },
    {
      value: "refunded",
      display: "refunded",
      color: blueGrey[800],
      textColor: "white",
      offer: false,
      launch: true,
      entry: false,
      ticketRefunded: true,
    },
    {
      value: "refunded:part",
      display: "refunded",
      color: blueGrey[600],
      textColor: "white",
      offer: false,
      launch: true,
      entry: false,
    },
    {
      value: "cancelled",
      display: "cancelled",
      color: grey[600],
      textColor: "white",
      offer: false,
      launch: true,
      entry: false,
    },
    {
      value: "withdrawn",
      display: "withdrawn",
      color: grey[600],
      textColor: "white",
      offer: false,
      launch: false,
      entry: false,
    },
    {
      value: "expired",
      display: "expired",
      color: grey[600],
      textColor: "white",
      offer: false,
      launch: false,
      entry: false,
    },
    {
      value: "updating",
      display: "updating",
      color: grey[0],
      textColor: "black",
      offer: false,
      launch: false,
      entry: false,
    },
  ];
  constants.offerStates = [];
  constants.launchStates = [];
  for (let state of constants.states) {
    if (state.offer) {
      constants.offerStates.push(state.value);
    }
    if (state.launch) {
      constants.launchStates.push(state.value);
    }
  }

  return constants;
}
